export const serviceConfigs = {
  "contract-pilot": {
    slug: "contract-pilot",
    code: "SVC-PILOT-24",
    category: "Service · Flight Crews",
    line1: "Daily",
    line2Italic: "",
    line2: "Contract Pilot",
    tagline: "Professional Flight Crews. Ready When You Need Them.",
    heroImage:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_elyon-aviation/artifacts/nci6fdgc_IMG_1247.webp",
    lead:
      "Whether you need a pilot for a single day, a multi-week assignment, or ongoing operational support, El Elyon Air provides experienced contract pilots who integrate seamlessly into your operation.",
    paragraphs: [
      "We understand that every flight represents your reputation, your passengers, and your investment. Our mission is to deliver safe, professional, and dependable flight operations with the flexibility today’s aircraft owners and operators require.",
      "From corporate travel and owner-flown support to Part 91 and Part 135 operations, we are committed to making every flight smooth, efficient, and stress-free.",
    ],
    highlights: [
      { label: "Assignment Length", value: "One Day → Ongoing" },
      { label: "Certifications", value: "ATP · Type-Rated" },
      { label: "Operations", value: "Part 91 · Part 135" },
      { label: "Reach", value: "Domestic · International" },
    ],
    closing: "Available for domestic and international assignments.",
  },

  "aircraft-delivery": {
    slug: "aircraft-delivery",
    code: "SVC-FERRY-24",
    category: "Service · Worldwide Delivery",
    line1: "Worldwide",
    line2Italic: "",
    line2: "Aircraft Delivery",
    tagline: "Trusted Aircraft Delivery — Anywhere in the World.",
    heroImage:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_elyon-aviation/artifacts/99608cp4_81FDC356-5790-4500-89B2-2C79DC6CB20C.webp",
    lead:
      "Every aircraft has a destination, and every delivery deserves meticulous planning and professional execution.",
    paragraphs: [
      "El Elyon Air provides worldwide aircraft ferry and delivery services with careful attention to flight planning, international regulations, customs coordination, weather analysis, and aircraft handling. Whether delivering a newly purchased aircraft, relocating a fleet asset, or supporting an international transaction, we manage each mission with precision and care.",
      "Our goal is simple: deliver your aircraft safely, efficiently, and ready for its next mission.",
    ],
    highlights: [
      { label: "Planning", value: "Route · Fuel · Permits" },
      { label: "Customs", value: "Coordinated" },
      { label: "Weather", value: "Routed & Reviewed" },
      { label: "Reach", value: "Intercontinental" },
    ],
    closing: "From local repositioning flights to intercontinental deliveries, your aircraft is in experienced hands.",
  },

  "owner-mentoring": {
    slug: "owner-mentoring",
    code: "SVC-MENTOR-24",
    category: "Service · Owner-Flown Mentoring",
    line1: "Owner-Flown",
    line2Italic: "",
    line2: "Mentoring",
    tagline: "Building Confidence Through Experience.",
    heroImage:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_elyon-aviation/artifacts/0e670phd_IMG_2833.webp",
    lead:
      "Owning an aircraft is more than an investment — it’s a gateway to freedom, opportunity, and adventure. Our mentoring program is designed to help owner-pilots become confident, capable, and proficient in the aircraft they fly.",
    paragraphs: [
      "Unlike traditional training, mentoring focuses on practical, real-world operations. We fly the missions you fly, helping you strengthen decision-making, cockpit management, operational planning, and confidence in a variety of environments.",
      "Whether transitioning into a new aircraft, expanding your operational capabilities, or refining your skills after initial training, our personalized mentoring provides guidance every step of the way.",
    ],
    highlights: [
      { label: "Focus", value: "Real-World Ops" },
      { label: "Format", value: "One-on-One" },
      { label: "Missions", value: "Yours · Not Simulated" },
      { label: "Stage", value: "Transition · Recurrent · Refinement" },
    ],
    closing: "Because confidence is earned one flight at a time.",
  },

  "aircraft-management": {
    slug: "aircraft-management",
    code: "SVC-MGMT-24",
    category: "Service · Aircraft Management",
    line1: "Aircraft",
    line2Italic: "",
    line2: "Management",
    tagline: "Professional Oversight. Personalized Service.",
    heroImage:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_elyon-aviation/artifacts/1w1mf68n_IMG_7235.webp",
    lead:
      "Aircraft ownership should be rewarding — not overwhelming.",
    paragraphs: [
      "El Elyon Air offers personalized aircraft management services designed to protect your investment while simplifying day-to-day operations. We coordinate scheduling, pilot staffing, maintenance planning, operational oversight, and regulatory compliance so your aircraft is always prepared when you need it.",
      "Whether you fly frequently or only occasionally, we tailor our management services to fit your unique operational needs, providing the peace of mind that comes from knowing your aircraft is cared for by experienced aviation professionals.",
    ],
    highlights: [
      { label: "Scheduling", value: "Managed" },
      { label: "Crew", value: "Staffed" },
      { label: "Maintenance", value: "Planned" },
      { label: "Compliance", value: "Assured" },
    ],
    closing: "You enjoy the freedom of ownership — we’ll take care of the details.",
  },
};
